import { emojiCategoryConfigs } from '@src/constants/emojiConfig';
import Picker, { EmojiClickData } from 'emoji-picker-react';
import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

import SpBottomMenuLayout from './SpBottomMenuLayout';

interface EmojiBottomMenuSpProps {
  handleCloseClick: () => void;
  handleEmojiClick: (emojiObject: EmojiClickData) => void;
}

const EmojiBottomMenuSp: React.FC<EmojiBottomMenuSpProps> = ({
  handleCloseClick,
  handleEmojiClick,
}) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const emojiPickerRef = useRef<HTMLDivElement>(null);
  const [swipeAfterPositionY, setSwipeAfterPositionY] = useState<string>('90svh');

  useEffect(() => {
    const preventFocus = () => {
      const searchInput = emojiPickerRef.current?.querySelector('input[type="text"]');
      if (searchInput instanceof HTMLInputElement) {
        searchInput.blur();
        searchInput.readOnly = false;
      }
    };

    preventFocus();
    const timer = setTimeout(preventFocus, 100);

    return () => clearTimeout(timer);
  }, []);

  const handleSwipeDown = () => {
    if (!isExpanded) {
      handleCloseClick();
      return;
    }

    setSwipeAfterPositionY('0px');
    setTimeout(() => {
      handleCloseClick();
      setIsExpanded(false);
    }, 100);
  };

  return createPortal(
    <>
      <SpBottomMenuLayout
        handleCloseClick={handleCloseClick}
        swipeAfterPositionY={swipeAfterPositionY}
        isSwipeAfter={isExpanded}
        onSwipeDown={handleSwipeDown}
        minHeight={300}
      >
        <div
          ref={emojiPickerRef}
          className='h-full pb-2 [&>*]:!rounded-none [&>*]:!border-none'
          style={{
            touchAction: 'auto',
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
          }}
        >
          <Picker
            open
            onEmojiClick={handleEmojiClick}
            skinTonesDisabled
            lazyLoadEmojis
            width='100%'
            height='100%'
            searchPlaceholder='絵文字を検索'
            categories={emojiCategoryConfigs}
          />
        </div>
      </SpBottomMenuLayout>
    </>,
    document.body,
  );
};

export default EmojiBottomMenuSp;
